<template>
  <div class="freeEditorial freeEditorialParsys parsys">
    <div class="column columns12bleed columns section">
      <div class="grid-row bleed">
        <div class="col-12">
          <div class="col1-par parsys">
            <div class="richHeader section">
              <div class="grid-row bleed">
                <div class="col-12">
                  <div class="c_014">
                      <span class="c_029-1">
                        <picture class="picture-element  analytics-target">
                          <source srcset="/static/hero-xtrail_HEADER.jpg, /static/hero-xtrail_HEADER.jpg 2x" media="(min-width: 60.0em)">
                          <source srcset="/static/hero-xtrail_HEADER.jpg, /static/hero-xtrail_HEADER.jpg 2x" media="(min-width: 36.3125em)">
                          <source srcset="/static/hero-xtrail_HEADER.jpg, /static/hero-xtrail_HEADER.jpg 2x" media="(min-width: 1.0em)">
                          <img src="/static/hero-xtrail_HEADER.jpg" alt="JOIN THE CLUB">
                        </picture>
                      </span>
                      <div class="wrapper">
                        <div class="heading-group">
                            <h2><span>POTPUNO NOVI<br>NISSAN X-TRAIL</span></h2>
                            <p><span>OSTANITE U TOKU</span></p>
                        </div>
                        <div class="content"> 
                          <p class="text">Čeka vas nova elektrifikovana porodična avantura. Da li ste spremni? Ispunite obrazac u nastavku i među prvima saznajte najnovije informacije o potpuno novom Nissanu X-Trail.</p>
                          <a href="https://www.youtube.com/watch?v=cT6NvdlgeV8" class="btn" target="_blank">OTKRIJTE VIŠE</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    <div class="contentZone section">
      <div class="content-zone container">
        <div class="link-zone">
          <div class="columns parsys">
            <div class="columns column section columns12">
              <div class="grid-row">
                <div class="col-centered col-6 center">
                  <div>
                    <div class="form section">
                      <div class="c_019">
                        <form novalidate="">
                          <fieldset>
                            <div class="parsys formBuilder">
                              <user></user>
                              <div class="extra-notice">
                                <p>Slanjem svojih podataka potvrđujem da želim da primam aktuelne vesti o odabranom modelu Nissan od strane ADRIATIC AUTO d.o.o.</p>
                              </div>
                              <gdpr></gdpr>
                              <submit></submit>
                            </div>
                          </fieldset>
                        </form>
                      </div>
                    </div>
                    <div class="notice">
                      <p>*Obavezna polja</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/components/form/User'
import Submit from '@/components/form/Submit'
import Gdpr from '@/components/form/Gdpr'

export default {
  name: 'Form',
  components: {
    User,
    Submit,
    Gdpr,
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .form-centered {
    padding: 0 16%;
    @media only screen and (max-width: 480px) {
      padding: 0;
    }
  }

  .title {
    margin-top: 30px;
  }
  .c_004 h2 {
    border-bottom: 0px;
  }
  .c_004 .heading-group {
    margin-bottom: 0px;
  }
  .content-zone {
    border-top: 1px solid #c1c1c1;
    margin: 3em auto 0;
  }
  .c_029-1 .picture-element img {
    width: 100%;
  }
  h2 {
  font-family: "Nissan Bold",Verdana,Arial,sans-serif;
    font-weight: 400;
    text-transform: uppercase;
    word-wrap: break-word;
    font-size: 1.5em;
    font-weight: bold;
  }
  .wrapper .content {
    a.btn {
      display: inline-block;
      color:#ffffff;
      background: #c3002f;
      padding:.8571428571em 20px;
      font-size: 13px;
      margin-top: 8px;
      font-family: "Nissan Regular",Verdana,Arial,sans-serif;
    }
    p.text {
      text-transform: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Form.vue